import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ViewUserDetail from "../component/users/viewUserDetail";
import * as userAction from "../../../redux/actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../library/common/Loader";
import { ORG_ID } from "../../../constant/constant";
import * as adminAction from "../../../redux/actions/adminCommonAction";

const ViewUserDetailContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userId = location?.state?.userId;

  const userData = useSelector((state) => state.getUserListDetsilsData);
  const dropDownData = useSelector(
    (state) => state.getDropdownDataKeyValue?.data
  );

  const showLoader = useSelector(
    (state) =>
      state.getUserListDetsilsData.isLoading ||
      state.getDropdownDataKeyValue.isLoading
  );
  const getUserListDetail = () => {
    const data = {
      userId: userId,
      orgId: ORG_ID(),
    };
    dispatch(userAction.getUserListDetsils(data));
  };

  const getDropDowndata = (productsID) => {
    const getDropdownDataKeyValueData = {
      orgId: ORG_ID(),
      flags: "5,6,12,22,23,24",
      productId: productsID,
    };
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  };

  useEffect(() => {
    dispatch(userAction.clearList());
    if (userId) {
      getUserListDetail();
    }
  }, []);

  return (
    <>
      {showLoader && <Loader />}
      <ViewUserDetail
        userData={userData?.data}
        getDropDowndata={getDropDowndata}
        dropDownData={dropDownData}
      />
    </>
  );
};

export default ViewUserDetailContainer;
